import { Box, Button, Container, IconButton, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import { KvixIcon } from "../../icons";
import { ClickableTitle } from "../../Other";
const useStyles = makeStyles((theme) => ({
    swiperPadding: {
        [theme.breakpoints.down("xl")]: {
            paddingRight: theme.spacing(0),
            paddingLeft: theme.spacing(0)
        },
        [theme.breakpoints.down("lg")]: {
            paddingRight: theme.spacing(0),
            paddingLeft: theme.spacing(0)
        },
        [theme.breakpoints.down("md")]: {
            paddingRight: theme.spacing(0),
            paddingLeft: theme.spacing(0)
        },
        [theme.breakpoints.down("sm")]: {
            paddingRight: theme.spacing(0),
            paddingLeft: theme.spacing(3)
        },
        [theme.breakpoints.down("xs")]: {
            paddingRight: theme.spacing(0),
            paddingLeft: theme.spacing(2),
            marginBottom: theme.spacing(4),
            overflow: "hidden"
        }
    },
    slide: {
        "&.swiper-slide": {
            width: "auto"
        }
    },
    navigationButton: {
        height: "40px",
        width: "40px"
    },
    channelButtons: {
        display: "flex",
        justifyContent: "flex-end",
        "& > *:nth-child(1)": {
            marginRight: 10
        },
        "& button": {
            borderRadius: 30,
            backgroundColor: "#80808024",
            "&:not(.Mui-disabled)": {
                "& svg": {
                    fill: theme.palette.primary.main
                }
            },
            "&.Mui-disabled": {
                backgroundColor: "#80808024"
            },
            "&:hover": {
                backgroundColor: "#80808024"
            }
        },
        "& .back": {
            transform: "rotate(-90deg)"
        },
        "& .forward": {
            transform: "rotate(90deg)"
        }
    },
    navTitleWrapper: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(1)
    },
    seeMore: {
        textTransform: "none",
        display: "flex",
        paddingRight: 0
    }
}));
export const SwiperWithArrows = ({ items = [], title = "", titleUrl, spaceBetween = 40, noArrows, children }) => {
    const classes = useStyles();
    const history = useHistory();
    const { t, ready } = useTranslation("general");
    const [swiper, setSwiper] = useState(null);
    const [isEnd, setIsEnd] = useState(true);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [isBeginning, setIsBeginning] = useState(true);
    const options = {
        slidesPerView: "auto",
        pagination: false,
        loop: false,
        allowTouchMove: true,
        spaceBetween: spaceBetween
    };
    const slideTo = (i) => {
        if (swiper && !swiper.destroyed) {
            swiper.slideTo(i);
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
        }
    };
    const handleSlideChange = () => {
        if (swiper && !swiper.destroyed) {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
        }
    };
    useEffect(() => {
        if (!swiper) {
            return;
        }
        if (items.length === 0) {
            setIsEnd(true);
            setIsBeginning(true);
        }
        else {
            setIsEnd(swiper.isEnd);
            setIsBeginning(swiper.isBeginning);
        }
    }, [items, swiper]);
    if (!ready) {
        return null;
    }
    return (
    // fix for padding on watch again
    React.createElement(Container, { maxWidth: "xl", className: classes.swiperPadding },
        React.createElement(Box, { className: classes.navTitleWrapper },
            React.createElement(ClickableTitle, { title: title, titleUrl: titleUrl }),
            isMobile ? (React.createElement(React.Fragment, null, titleUrl && (React.createElement(Button, { variant: "text", color: "primary", onClick: () => history.push(titleUrl), className: classes.seeMore },
                t("showAll"),
                React.createElement(KvixIcon.Chevron.Right, null))))) : (React.createElement(React.Fragment, null, !noArrows && (React.createElement("div", { className: classes.channelButtons },
                React.createElement(IconButton, { disabled: isBeginning, onClick: () => slideTo((swiper === null || swiper === void 0 ? void 0 : swiper.activeIndex) - 1), className: classes.navigationButton },
                    React.createElement(KvixIcon.Expand.ExpandLess, { className: "back" })),
                React.createElement(IconButton, { disabled: isEnd, onClick: () => slideTo((swiper === null || swiper === void 0 ? void 0 : swiper.activeIndex) + 1), className: classes.navigationButton },
                    React.createElement(KvixIcon.Expand.ExpandLess, { className: "forward" }))))))),
        React.createElement(Swiper, Object.assign({}, options, { onSwiper: (swp) => {
                setSwiper(swp);
                setIsBeginning(swp.isBeginning);
                setIsEnd(swp.isEnd);
            }, onSlideChange: handleSlideChange }), items.map((item) => (React.createElement(SwiperSlide, { key: item.session.id, className: classes.slide }, children(item)))))));
};
//# sourceMappingURL=SwiperWithArrows.js.map